import type { IntlShape } from 'react-intl';
import type { ToolUseItem } from '../../../../contracts/harness.types';

import {
  renderStandardExportToolUse,
  type OpenExportDocumentPayload,
} from './shared/exportDocumentPreview';

export const renderGenerateCsvToolUse = (
  item: ToolUseItem,
  intl: IntlShape,
  onOpenDocumentExport?: (payload: OpenExportDocumentPayload) => void
): JSX.Element | null =>
  renderStandardExportToolUse(
    item,
    intl,
    {
      artefactType: 'csv',
      titleFallback: { id: 'pjArtCsv01', defaultMessage: 'CSV export' },
    },
    onOpenDocumentExport
  );
